export class Timer
{
  private _duration:number = 0.500;
  private _elapsed:number = 0;
  private _finished:boolean = false;
  private _running:boolean = false ;
  private _lastTime:number = null;

  get finished(){ return this._finished; }
  get running(){ return this._running; }

  get state(){ return this._finished ? -1 : this._running ? ( this._elapsed / this._duration ) : -2; }
  get elapsed(){ return this._elapsed; }
  get duration(){ return this._duration; }

  constructor( duration:number )
  {
    this._duration = duration;
  }


  start( duration:number = undefined )
  {
    if ( duration !== undefined )
    {
      this._duration = duration;
    }
    
    this._elapsed  = 0;
    this._running  = true;
    this._finished = false;    
  }

  reset()
  {
    this._elapsed  = 0;
    this._running  = false;
    this._finished = false;    
  }

  setFinished()
  {
    this._running = false;
    this._finished = true;
    this._elapsed = this.duration;
  }

  startMS( durationMS:number  = undefined )
  {
    if ( durationMS === undefined )
    {
      this.start();
    }
    else
    {
      this.start( durationMS / 1000 );
    }    
  } 

  updateMS( deltaMilliseconds:number )
  {
    this.update( deltaMilliseconds / 1000 );
  }

  update( deltaSeconds:number = undefined )
  {
    if ( ! this._running )
    {
      return;
    }

    if ( deltaSeconds == undefined )
    {
      let now = new Date().getTime();
      
      if ( this._lastTime === null )
      {
        this._lastTime = now;
      }

      deltaSeconds = now - this._lastTime;
      this._lastTime = now;
    }

    this._elapsed += deltaSeconds;

    if ( this._elapsed > this._duration )
    {
      this._running = false;
      this._finished = true;
    }
    
  }

}